/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const CheckStatusDto = {
    Passed: 'PASSED',
    Failed: 'FAILED',
    Skipped: 'SKIPPED'
} as const;

export type CheckStatusDto = typeof CheckStatusDto[keyof typeof CheckStatusDto];



